import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b0c8745"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "refund-modal-title"
}, "¥ 发起退款流程", -1));
const _hoisted_2 = {
  class: "refund-header"
};
const _hoisted_3 = {
  class: "refund-header__col"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__label"
}, "订单总额", -1));
const _hoisted_5 = {
  class: "refund-header__amount"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__divider"
}, null, -1));
const _hoisted_7 = {
  class: "refund-header__col refund-header__col--right"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__label"
}, "用户申退", -1));
const _hoisted_9 = {
  class: "refund-header__amount"
};
const _hoisted_10 = {
  class: "amount-input"
};
const _hoisted_11 = {
  class: "amount-input__prefix"
};
const _hoisted_12 = {
  class: "refund-reason-label"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "refund-reason-label__text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "refund-reason-label__required"
}, "*"), /*#__PURE__*/_createTextVNode(" 退款原因 ")], -1));
const _hoisted_14 = {
  class: "refund-reason-label__tags"
};
const _hoisted_15 = {
  class: "screenshot-upload"
};
const _hoisted_16 = {
  key: 0,
  class: "screenshot-upload__loading"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "screenshot-upload__trigger"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "screenshot-upload__hint"
}, "支持 PNG, JPG 格式，最多 3 张，可直接 Ctrl+V 粘贴截图", -1));
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import { awaitWrap, OK } from '@/common';
import { uploadAuditScreenshot } from '@/api/goodsInfo';
import { refundSubmit, retryRefundSubmit } from '@/api/orderApi';
export default /*#__PURE__*/_defineComponent({
  __name: 'RefundModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    orderInfo: null
  },
  emits: ['update:modalVisible', 'initRefund', 'updateList'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const refundReasons = ['未成年', '协商一致', '误操作'];
    const refundAmount = ref();
    const reasonForRefund = ref('');
    const fileList = ref([]);
    const uploadLoading = ref(false);
    const submitLoading = ref(false);
    const amountTouched = ref(false);
    const reasonTouched = ref(false);
    const screenshotTouched = ref(false);
    const currencyText = computed(() => {
      var _props$orderInfo, _props$orderInfo2;
      return ((_props$orderInfo = props.orderInfo) === null || _props$orderInfo === void 0 ? void 0 : _props$orderInfo.currency) || ((_props$orderInfo2 = props.orderInfo) === null || _props$orderInfo2 === void 0 ? void 0 : _props$orderInfo2.refundCurrency) || '¥';
    });
    const amountValid = computed(() => {
      var _props$orderInfo3;
      const amount = Number(refundAmount.value);
      const maxAmount = Number(((_props$orderInfo3 = props.orderInfo) === null || _props$orderInfo3 === void 0 ? void 0 : _props$orderInfo3.amount) || 0);
      return amount > 0 && amount <= maxAmount;
    });
    const amountError = computed(() => amountTouched.value && !amountValid.value);
    const reasonError = computed(() => reasonTouched.value && !reasonForRefund.value.trim());
    const screenshotError = computed(() => screenshotTouched.value && !fileList.value.length);
    const toMoney = value => {
      const num = Number(value || 0);
      return Number.isNaN(num) ? '0.00' : num.toFixed(2);
    };
    const fillReason = reason => {
      reasonForRefund.value = reason;
      reasonTouched.value = false;
    };
    const init = () => {
      refundAmount.value = undefined;
      reasonForRefund.value = '';
      fileList.value = [];
      uploadLoading.value = false;
      submitLoading.value = false;
      amountTouched.value = false;
      reasonTouched.value = false;
      screenshotTouched.value = false;
    };
    const handleCancel = () => {
      init();
      emit('update:modalVisible', false);
      emit('initRefund');
    };
    const removeScreenshot = file => {
      fileList.value = fileList.value.filter(item => item.uid !== file.uid);
    };
    const uploadFile = async file => {
      var _props$orderInfo4;
      if (!file.type.includes('image')) {
        message.error('请上传图片');
        return;
      }
      if (fileList.value.length >= 3 || uploadLoading.value) return;
      const uid = `${Date.now()}-${Math.random()}`;
      fileList.value.push({
        uid,
        name: file.name || 'image.png',
        status: 'uploading',
        url: ''
      });
      uploadLoading.value = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('businessId', (_props$orderInfo4 = props.orderInfo) === null || _props$orderInfo4 === void 0 ? void 0 : _props$orderInfo4.orderNo);
      formData.append('businessType', 'ORDER_REFUND');
      formData.append('accessAttribute', '1');
      formData.append('desc', '');
      const [err, res] = await awaitWrap(uploadAuditScreenshot(formData));
      uploadLoading.value = false;
      if (err || (res === null || res === void 0 ? void 0 : res.code) !== OK) {
        fileList.value = fileList.value.filter(item => item.uid !== uid);
        message.error('上传图片失败');
        return;
      }
      const fileItem = fileList.value.find(item => item.uid === uid);
      if (fileItem) {
        var _res$data;
        fileItem.url = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.fileUrl;
        fileItem.status = 'done';
      }
      screenshotTouched.value = false;
    };
    const uploadImage = async e => {
      await uploadFile(e.file);
    };
    const refundAll = () => {
      var _props$orderInfo5, _props$orderInfo6;
      if (isNaN(Number((_props$orderInfo5 = props.orderInfo) === null || _props$orderInfo5 === void 0 ? void 0 : _props$orderInfo5.amount))) return message.error('金额格式错误');
      refundAmount.value = Number(Number((_props$orderInfo6 = props.orderInfo) === null || _props$orderInfo6 === void 0 ? void 0 : _props$orderInfo6.amount).toFixed(2));
      amountTouched.value = false;
    };
    const submitRefund = async () => {
      var _props$orderInfo7, _fileList$value$map, _props$orderInfo8, _props$orderInfo10;
      if (!amountValid.value) {
        amountTouched.value = true;
        return;
      }
      if (!reasonForRefund.value.trim()) {
        reasonTouched.value = true;
        return;
      }
      if (!fileList.value.length) {
        screenshotTouched.value = true;
        return;
      }
      submitLoading.value = true;
      let params = {
        orderNo: (_props$orderInfo7 = props.orderInfo) === null || _props$orderInfo7 === void 0 ? void 0 : _props$orderInfo7.orderNo,
        refundAmount: Number(refundAmount.value).toFixed(2),
        refundReason: reasonForRefund.value.trim(),
        customerComplaintUrl: (_fileList$value$map = fileList.value.map(item => item.url)) === null || _fileList$value$map === void 0 ? void 0 : _fileList$value$map.join(',')
      };
      if ((_props$orderInfo8 = props.orderInfo) !== null && _props$orderInfo8 !== void 0 && _props$orderInfo8.isEdit) {
        var _props$orderInfo9;
        params = {
          ...params,
          // TODO: 退款失败重提联调时需确认后端要订单 id 还是退款申请 id/orderRefundId。
          id: (_props$orderInfo9 = props.orderInfo) === null || _props$orderInfo9 === void 0 ? void 0 : _props$orderInfo9.id
        };
      }
      const fn = (_props$orderInfo10 = props.orderInfo) !== null && _props$orderInfo10 !== void 0 && _props$orderInfo10.isEdit ? retryRefundSubmit : refundSubmit;
      const [err, res] = await awaitWrap(fn(params));
      submitLoading.value = false;
      if (err) return message.error('提交失败');
      if ((res === null || res === void 0 ? void 0 : res.code) === OK) {
        message.success('提交成功');
        handleCancel();
        emit('updateList');
        Modal.confirm({
          title: '提示',
          centered: true,
          content: '退款申请已提交！可前往"飞书审批"查看审批进程'
        });
      }
    };
    const handleGlobalPaste = event => {
      var _event$clipboardData;
      if (!props.modalVisible || !((_event$clipboardData = event.clipboardData) !== null && _event$clipboardData !== void 0 && (_event$clipboardData = _event$clipboardData.files) !== null && _event$clipboardData !== void 0 && _event$clipboardData.length)) return;
      uploadFile(event.clipboardData.files[0]);
    };
    watch(() => props.orderInfo, orderInfo => {
      var _orderInfo$customerCo;
      if (!orderInfo) return;
      refundAmount.value = Number(orderInfo.refundAmount || orderInfo.amount || 0.01);
      reasonForRefund.value = orderInfo.refundReason || '';
      fileList.value = ((_orderInfo$customerCo = orderInfo.customerComplaintUrl) === null || _orderInfo$customerCo === void 0 ? void 0 : _orderInfo$customerCo.split(',').map(item => {
        return {
          uid: Math.random(),
          name: 'image.png',
          status: 'done',
          url: item
        };
      })) || [];
    }, {
      immediate: true
    });
    watch(() => props.modalVisible, visible => {
      amountTouched.value = false;
      reasonTouched.value = false;
      screenshotTouched.value = false;
      if (!visible) init();
    });
    onMounted(() => document.addEventListener('paste', handleGlobalPaste));
    onBeforeUnmount(() => document.removeEventListener('paste', handleGlobalPaste));
    return (_ctx, _cache) => {
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        "confirm-loading": submitLoading.value,
        "ok-text": "提交审批",
        "cancel-text": "取消",
        "ok-button-props": {
          danger: true
        },
        width: "560px",
        onOk: submitRefund,
        onCancel: handleCancel
      }, {
        title: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => {
          var _props$orderInfo11, _props$orderInfo12;
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(currencyText)) + _toDisplayString(toMoney((_props$orderInfo11 = __props.orderInfo) === null || _props$orderInfo11 === void 0 ? void 0 : _props$orderInfo11.amount)), 1)]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString((_props$orderInfo12 = __props.orderInfo) !== null && _props$orderInfo12 !== void 0 && _props$orderInfo12.refundAmount ? `${_unref(currencyText)}${toMoney(__props.orderInfo.refundAmount)}` : '未明确'), 1)])]), _createVNode(_component_a_form, {
            layout: "vertical"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "退款金额",
              required: "",
              "validate-status": _unref(amountError) ? 'error' : '',
              help: _unref(amountError) ? '请输入大于0且不超过订单原金额的退款金额' : ''
            }, {
              default: _withCtx(() => {
                var _props$orderInfo13, _props$orderInfo14;
                return [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_unref(currencyText)), 1), _createVNode(_component_a_input_number, {
                  value: refundAmount.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => refundAmount.value = $event),
                  min: 0.01,
                  max: Number(((_props$orderInfo13 = __props.orderInfo) === null || _props$orderInfo13 === void 0 ? void 0 : _props$orderInfo13.amount) || 0),
                  controls: false,
                  placeholder: `最多可退 ${toMoney((_props$orderInfo14 = __props.orderInfo) === null || _props$orderInfo14 === void 0 ? void 0 : _props$orderInfo14.amount)}`,
                  style: {
                    "flex": "1"
                  }
                }, null, 8, ["value", "min", "max", "placeholder"]), _createElementVNode("span", {
                  class: "amount-input__suffix",
                  onClick: refundAll
                }, "全额")])];
              }),
              _: 1
            }, 8, ["validate-status", "help"]), _createVNode(_component_a_form_item, {
              "validate-status": _unref(reasonError) ? 'error' : '',
              help: _unref(reasonError) ? '请输入退款原因' : ''
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(refundReasons, item => {
                return _createVNode(_component_a_tag, {
                  key: item,
                  onClick: $event => fillReason(item)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["onClick"]);
              }), 64))])]), _createVNode(_component_a_textarea, {
                value: reasonForRefund.value,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => reasonForRefund.value = $event),
                maxlength: 200,
                rows: 4,
                placeholder: "请输入退款原因，该原因将同步至微信支付平台..."
              }, null, 8, ["value"])]),
              _: 1
            }, 8, ["validate-status", "help"]), _createVNode(_component_a_form_item, {
              required: "",
              "validate-status": _unref(screenshotError) ? 'error' : '',
              help: _unref(screenshotError) ? '请至少上传一张客诉截图' : ''
            }, {
              label: _withCtx(() => [_createTextVNode("客诉截图")]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, file => {
                return _openBlock(), _createElementBlock("div", {
                  key: file.uid,
                  class: "screenshot-upload__item"
                }, [file.status === 'uploading' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_unref(LoadingOutlined))])) : (_openBlock(), _createElementBlock(_Fragment, {
                  key: 1
                }, [_createVNode(_component_a_image, {
                  src: file.url,
                  width: 72,
                  height: 72,
                  style: {
                    "object-fit": "cover"
                  }
                }, null, 8, ["src"]), _createElementVNode("button", {
                  class: "screenshot-upload__remove",
                  type: "button",
                  onClick: $event => removeScreenshot(file)
                }, "×", 8, _hoisted_17)], 64))]);
              }), 128)), fileList.value.length < 3 ? (_openBlock(), _createBlock(_component_a_upload, {
                key: 0,
                "custom-request": uploadImage,
                "show-upload-list": false,
                accept: ".png,.jpg,.jpeg"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_unref(PlusOutlined)), _hoisted_19])]),
                _: 1
              })) : _createCommentVNode("", true)]), _hoisted_20]),
              _: 1
            }, 8, ["validate-status", "help"])]),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});